module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    staticClass: "info p-40 pt-30"
  }, [_c('i', {
    staticClass: "ion ion-heart-broken"
  }), _vm._v(" "), _c('h1', {
    staticClass: "mb-5"
  }, [_vm._v("404 page not found")]), _vm._v(" "), _c('p', {
    staticClass: "mb-5"
  }, [_vm._v("We couldn't find the page you are looking for. ")]), _vm._v(" "), _c('p', [_vm._v("You can browse our "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("homepage")]), _vm._v(" or use the navigation bar above.")], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-427f8d8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = 610
// module chunks = 1